// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"c028561c","149":"6864ff9b","247":"e31e2292","251":"d8683604","286":"4808e333","320":"3d32b0ff","378":"623e9b0f","513":"449d4ce6","603":"3737e46c","632":"e3a1cae2","650":"cf1cf3c1","762":"9bdaf9aa","910":"a4e899ad","963":"a51bbcdf"}[chunkId] + ".chunk.js";
};